'use client';

import { useCallback } from 'react';
import { useAuthStore } from '@/features/auth/stores/auth-store';

export interface SupportContextSnapshot {
  url: string;
  pathname: string;
  userAgent: string;
  viewport: string;
  language: string;
  timestamp: string;
  user?: {
    id: string;
    name: string;
    email: string;
    role: string;
  };
  company?: {
    id: string;
    name: string;
    cui: string | null;
  };
}

export function useSupportContext() {
  const user = useAuthStore((s) => s.user);
  const company = useAuthStore((s) => s.company);

  const snapshot = useCallback((): SupportContextSnapshot => {
    const win = typeof window !== 'undefined' ? window : null;
    const nav = typeof navigator !== 'undefined' ? navigator : null;
    return {
      url: win?.location.href ?? '',
      pathname: win?.location.pathname ?? '',
      userAgent: nav?.userAgent.split(')')[0]?.concat(')') ?? '',
      viewport: win ? `${win.innerWidth}x${win.innerHeight}` : '',
      language: nav?.language ?? '',
      timestamp: new Date().toISOString(),
      user: user
        ? {
            id: user.id,
            name: user.name,
            email: user.email,
            role: user.role,
          }
        : undefined,
      company: company
        ? {
            id: company.id,
            name: company.name,
            cui: company.cui,
          }
        : undefined,
    };
  }, [user, company]);

  return { snapshot };
}
